import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MatPaginatorIntlPt } from '../../shared/mat-paginator-intl-pt';
import { ExtratoProcessamentoEfdComponent } from './extrato-processamento-efd.component';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
    declarations: [
        ExtratoProcessamentoEfdComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatIconModule,
        MatMenuModule,
        MatTooltipModule,
        MatRadioModule,
        MatDividerModule,
        NgxSpinnerModule,
        NgxMaskDirective,
        NgxMaskPipe,
        RouterModule
    ],
    providers: [
        provideNgxMask(),
        { provide: MatPaginatorIntl, useClass: MatPaginatorIntlPt }
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ExtratoProcessamentoEfdModule {}
